<div class="card h-full">
  <div class="card-header">
    <h3 class="card-title">Social Media</h3>
  </div>
  <div class="card-body p-0">
    <kendo-grid
      [kendoGridBinding]="repState.repSocialMedia"
      (edit)="editHandler($event)"
      (add)="addHandler($event)"
      (save)="saveHandler($event)"
      (cancel)="cancelHandler($event)"
    >
      <ng-template kendoGridToolbarTemplate>
        <div class="flex items-center p-2">
          <button gdAdminOnly
            type="button"
            kendoGridAddCommand
            kendoButton
            look="flat"
            icon="plus"
            class="mr-2"
          >
            Add New Record
          </button>
          <button gdAdminOnly
            type="button"
            kendoButton
            look="flat"
            icon="refresh"
            class="ml-auto"
          >
            Refresh
          </button>
        </div>
      </ng-template>
      <kendo-grid-column field="socialMedia" title="Social Media" width="140">
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-dropdownlist
            class="w-full"
            [data]="activeApprovedSocialMedia"
            textField="socialMedia"
            valueField="approvedSocialMediaId"
            valuePrimitive="true"
            [popupSettings]="{ height: 200 }"
            [formControl]="formGroup.get('approvedSocialMediaID')"
          >
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="accountName" title="Account Name" width="180">
        <ng-template
          kendoGridEditTemplate
          let-column="column"
          let-formGroup="formGroup"
          let-isNew="isNew"
        >
          <input
            class="k-textbox w-full"
            [formControl]="formGroup.get(column.field)"
            maxlength="255"
            kendoTextBox
          />
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="startDate" title="Start Date" width="120">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.startDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="w-full"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="endDate" title="End Date" width="120">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.endDate | date : 'MM/dd/yyyy' }}
        </ng-template>
        <ng-template
          kendoGridEditTemplate
          let-dataItem="dataItem"
          let-column="column"
          let-formGroup="formGroup"
        >
          <kendo-datepicker
            class="w-full"
            type="date"
            [formControl]="formGroup.get(column.field)"
            format="MM/dd/yyyy"
            [formatPlaceholder]="
              asDateInput({ year: 'YYYY', month: 'MM', day: 'DD' })
            "
          ></kendo-datepicker>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Action" width="160" gdAdminOnly>
        <ng-template
          kendoGridCellTemplate
          let-isNew="isNew"
          let-dataItem="dataItem"
          let-formGroup="formGroup"
        >
          <div class="flex gap-2">
            <button kendoGridEditCommand [primary]="true" kendoButton look="flat" size="small" gdAdminOnly>
              <span class="fas fa-edit"></span>
            </button>
            <button kendoGridSaveCommand [disabled]="formGroup?.invalid" kendoButton look="flat" size="small" gdAdminOnly>
              <span class="fas fa-save"></span>
            </button>
            <button kendoGridCancelCommand kendoButton look="flat" size="small">
              <span class="fas fa-times"></span>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
  </div>
</div>
